<script lang="ts" setup></script>

<template>
  <div
    class="flex flex-wrap items-center justify-end gap-1 p-4 text-sm font-medium text-green-100 [&>svg]:h-5 [&>svg]:shrink-0"
  >
    <slot />
  </div>
</template>

<style scoped></style>
